export default {
  to: "Aan: ",

  attachment: {
    label: "Bijlagen: ",
    pdf: "{{number}}.pdf",
  },

  subject: {
    label: 'Onderwerp: ',
    value: "Factuur: {{number}} | {{clientName}}",
  },

  message: {
    label: "Bericht: ",
  },

  sendMeCopy: "Stuur mij een kopie",

  button: {
    send: "Verstuur",
    cancel: "Annuleren",
  }
}
